// extracted by mini-css-extract-plugin
module.exports = {"root":"NoLookBoardsModal_root__2xnu1","title":"NoLookBoardsModal_title__1EELw","border":"NoLookBoardsModal_border__2e3wc"};